import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import Icon from '../Icon/index.esm.js';
import Spinner from '../Spinner/index.esm.js';
import Flex from '../Flex/index.esm.js';
import { useId } from '@reach/auto-id';
import TextInput from '../TextInput/index.esm.js';

var SearchInput = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$id = props.id,
      id = _props$id === void 0 ? "search-input-" + useId() : _props$id,
      _props$label = props.label,
      label = _props$label === void 0 ? 'Search' : _props$label,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? label : _props$placeholder,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      rest = _objectWithoutPropertiesLoose(props, ["id", "label", "placeholder", "loading"]);

  return React__default.createElement(Box, {
    position: "relative",
    width: "w-full"
  }, React__default.createElement(TextInput, _extends({
    ref: ref,
    id: id,
    borderRadius: "rounded-full",
    padding: "pl-10",
    label: label,
    placeholder: placeholder,
    autoCapitalize: "off",
    autoComplete: "off",
    autoCorrect: "off",
    spellCheck: "false",
    type: "search",
    enterKeyHint: "search",
    inputMode: "search"
  }, rest)), React__default.createElement(Flex, {
    position: "absolute",
    inset: ['inset-y-0', 'left-0'],
    alignItems: "items-center",
    padding: "pl-4",
    pointerEvents: "pointer-events-none"
  }, loading ? React__default.createElement(Spinner, {
    color: "text-gray-500"
  }) : React__default.createElement(Icon, {
    name: "search",
    color: "text-gray-400"
  })));
});

if (__DEV__) {
  SearchInput.displayName = 'SearchInput';
}

export default SearchInput;
//# sourceMappingURL=index.esm.js.map
